import request from '@/utils/request'

let PasswordApi = {
  /*获取数据*/
  getData(data) {
    return request._get('/shop/plus.password.password/index', data);
  },
  // 详情
  detail(data) {
    return request._get('/shop/plus.password.password/detail', data);
  },
  /*添加密码*/
  add(data) {
    return request._post('/shop/plus.password.password/add', data);
  },

  /*修改密码*/
  edit(data) {
    return request._post('/shop/plus.password.password/edit', data);
  },
  /*删除密码*/
  del(data) {
    return request._post('/shop/plus.password.password/del', data);
  },
/*关联资产*/
relevancy(data) {
  return request._post('/shop/plus.password.password/relevancy', data);
},
//获取类型
getCode(data) {
  return request._get('/shop/plus.password.password/getCode', data);
},
//获取公司
getCompany(data) {
  return request._post('/shop/plus.password.password/getCompany', data);
},
//获取公司状态
getCompanyStatus(data) {
  return request._post('/shop/plus.password.password/getCompanyStatus', data);
},

//获取资产
getUserAsset(data) {
  return request._post('/shop/plus.password.password/getUserAsset', data);
},
//获取资产状态
getAssetStatus(data) {
  return request._post('/shop/plus.password.password/getAssetStatus', data);
},
//获取资产类型
getAssetType(data) {
  return request._post('/shop/plus.password.password/getAssetType', data);
},

}
export default PasswordApi;



// WEBPACK FOOTER //
// ./src/api/password.js